"use strict";

/* eslint-disable no-param-reassign */
/* eslint-disable dot-notation */
module.exports = /*@ngInject*/function ($q, $window, $cookies, $location) {
  return {
    request: function request(_request) {
      _request.headers = _request.headers || {};
      var impersonateId = $cookies.get('RSS:SPOOF:USER');
      if (impersonateId) {
        _request.headers['impersonate-id'] = impersonateId;
      }
      var deferred = $q.defer();
      deferred.resolve(_request);
      return deferred.promise;
    },
    responseError: function responseError(response) {
      if (response.status === 401) {
        $window.location.reload();
      } else if (response.status > 400 && response.status !== 409) {
        var errorParams = {
          statusCode: response.status,
          message: response.data && response.data.message ? response.data.message : 'Unknown error'
        };
        $location.path('/error').search(errorParams);
      }
      return $q.reject(response.data || response);
    }
  };
};